import { Vraag } from '@models/claims';
import { IBaseVraagboomResultaat, VraagboomTextResultaat } from '@models/vragenboom';

// @dynamic
export class RequiredValidator {
  static isValid<TResultaat extends IBaseVraagboomResultaat>(vraag: Vraag, resultaat: TResultaat): boolean {
    if (vraag == null || (vraag.verplicht && resultaat == null)) {
      return false;
    }
    return true;
  }

  static isValidText(vraag: Vraag, resultaat: VraagboomTextResultaat): boolean {
    if (vraag == null || vraag.verplicht && (resultaat == null || resultaat.value.trim() === '')) {
      return false;
    }
    return true;
  }
}
